<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/" class="vx-row">
            <feather-icon icon="ArrowLeft" svgClasses="text-dark" />
            <h3>Back</h3>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="chart-containers">
      <h3>Customer Profile Section</h3>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <vs-input
              label="Customer Name"
              placeholder="Enter Customer Name"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.firstName"
              class="left-width"
              readonly
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              label="Customer Email"
              placeholder="Enter Customer Email"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.email"
              class="right-width"
              readonly
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <vs-input
              label="Phone"
              placeholder="Enter Phone Number"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.number"
              class="left-width"
              readonly
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              label="Customet Account"
              placeholder="Enter Account"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.accountNo"
              class="right-width"
              readonly
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <vs-input
              label="Customer Meater Id"
              placeholder="Enter Meater Id"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="userInfo.clientData.hwSerialNumber"
              class="left-width"
              readonly
            />
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <vs-input
              label="Customer Address"
              placeholder="Enter Customer Address"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="form.state"
              class="right-width"
              readonly
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <div class="button_content">
        <vs-button
          class="buttons"
          @click="$router.push('/editProfile').catch(() => {})"
        >
          Edit Profile
        </vs-button>
        <vs-button
          class="button2"
          @click="$router.push('/changePassword').catch(() => {})"
        >
          Change Password
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { searchCustomerId } from "@/services/dashboard";
export default {
  data() {
    return {
      items: ["PAN Card", "Aadhaar Card", "Driving License", "Passport"],
      Monthly_cost: 200,
      current_balance: 400,
      LCO_Name: "sai cable",
      Set_TOP_BOX_NUM: 8738945,
      clients: [],
      amount: 0,
      firstName: JSON.parse(localStorage.getItem("in:profile")).firstname,
      stbnumber: JSON.parse(localStorage.getItem("in:profile")).hwSerialNumber,
      accountNo: JSON.parse(localStorage.getItem("in:profile")).accountNo,
      phone: JSON.parse(localStorage.getItem("in:profile")).phone,
      email: JSON.parse(localStorage.getItem("in:profile")).email,
      balance: JSON.parse(localStorage.getItem("in:profile")).balanceAmount,
      form: {
        title: "",
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        email: "",
        number: "",
        address: "",
        city: "",
        phone: "",
        state: "",
        balanceamount: "",
        country: "",
        postCode: "",
        stbNumber: "",
        planName: "",
        expiryDate: "",
        planAmount: "",
        voucherCode: "",
        movieList: "",
        movieAmount: "",
        voucherId: "",
        accountNo: "",
        movieListValue: ""
      }
    };
  },

  components: {},
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    }
  },

  methods: {
    async myFunction() {
      try {
        const response = await searchCustomerId(this.userInfo.clientId);
        this.clientId = response.data.id;
        this.customers = response.data;
        console.log("mounted", this.form.hwSerialNumber);
        this.show = true;
        var clientdata = response.data.orderData;
        console.log(this.amount);
        this.amount = 0;
        clientdata.map(e => {
          if (e.status === "ACTIVE") {
            this.amount = this.amount + e.price;
          }
        });
        this.form = {
          title: this.customers.title,
          firstName: this.customers.firstname,
          lastName: this.customers.lastname,
          price: this.customers.orderData[0].price,
          id: this.customers.orderData[0].id,
          balanceamount: this.customers.balanceAmount,
          email: this.customers.email,
          number: this.customers.phone,
          address: this.customers.address,
          city: this.customers.city,
          state: this.customers.state,
          country: this.customers.country,
          postCode: this.customers.zip,
          stbNumber: this.customers.hwSerialNumber,
          planName: this.customers.orderData[0].planDescription,
          planAmount: this.customers.planamount,
          accountNo: this.customers.accountNo
        };
      } catch (err) {
        console.log(err);
      }
    }
  },

  mounted() {
    this.myFunction();
  },
  watch: {}
};
</script>

<style>
.chart-containers {
  background: #fff;
  padding: 20px;
  margin: 0 1rem;
  border-radius: 20px;
}

.button_content {
  display: flex;
  justify-content: space-evenly;
}
.buttons {
  width: 200px;
  background-color: #30a852;
  font-weight: bold;
  height: 40px;
  color: #fff;
  border: 1px solid #30a852;
  border-radius: 5px;
  margin-right: 20px;
}
.right-width {
  width: 440px;
  border-radius: 4px;
}
.left-width {
  width: 430px;
  border-radius: 4px;
}
.v-select {
  width: 420px;
}
</style>
